import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FormattedInputs from './FormattedInputs';
import ClientProvider from './client';
export default createDemo(import.meta.url, FormattedInputs, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/formatted-inputs/FormattedInputs.tsx",
    "fileName": "FormattedInputs.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { IMaskInput } from 'react-imask';\nimport { NumericFormat } from 'react-number-format';\nimport Stack from '@mui/material/Stack';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport TextField from '@mui/material/TextField';\nimport FormControl from '@mui/material/FormControl';\n\ninterface CustomProps {\n  onChange: (event: { target: { name: string; value: string } }) => void;\n  name: string;\n}\n\nconst TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(\n  function TextMaskCustom(props, ref) {\n    const { onChange, ...other } = props;\n    return (\n      <IMaskInput\n        {...other}\n        mask=\"(#00) 000-0000\"\n        definitions={{\n          '#': /[1-9]/,\n        }}\n        inputRef={ref}\n        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}\n        overwrite\n      />\n    );\n  },\n);\n\nexport default function FormattedInputs() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const [values, setValues] = React.useState({\n    textmask: '(100) 000-0000',\n    numberformat: '1320',\n  });\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setValues({\n      ...values,\n      [event.target.name]: event.target.value,\n    });\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={2}>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${id}-input`}>react-imask</InputLabel>\n        <Input\n          value={values.textmask}\n          onChange={handleChange}\n          name=\"textmask\"\n          id={`${id}-input`}\n          inputComponent={TextMaskCustom as any}\n        />\n      </FormControl>\n      <NumericFormat\n        value={values.numberformat}\n        onChange={handleChange}\n        customInput={TextField}\n        thousandSeparator\n        valueIsNumericString\n        prefix=\"$\"\n        variant=\"standard\"\n        label=\"react-number-format\"\n      />\n    </Stack>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 71,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { IMaskInput } from 'react-imask';\nimport { NumericFormat } from 'react-number-format';\nimport Stack from '@mui/material/Stack';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport TextField from '@mui/material/TextField';\nimport FormControl from '@mui/material/FormControl';\n\ninterface CustomProps {\n  onChange: (event: { target: { name: string; value: string } }) => void;\n  name: string;\n}\n\nconst TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(\n  function TextMaskCustom(props, ref) {\n    const { onChange, ...other } = props;\n    return (\n      <IMaskInput\n        {...other}\n        mask=\"(#00) 000-0000\"\n        definitions={{\n          '#': /[1-9]/,\n        }}\n        inputRef={ref}\n        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}\n        overwrite\n      />\n    );\n  },\n);\n\nexport default function FormattedInputs() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const id = React.useId();\n  const [values, setValues] = React.useState({\n    textmask: '(100) 000-0000',\n    numberformat: '1320',\n  });\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setValues({\n      ...values,\n      [event.target.name]: event.target.value,\n    });\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={2}>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${id}-input`}>react-imask</InputLabel>\n        <Input\n          value={values.textmask}\n          onChange={handleChange}\n          name=\"textmask\"\n          id={`${id}-input`}\n          inputComponent={TextMaskCustom as any}\n        />\n      </FormControl>\n      <NumericFormat\n        value={values.numberformat}\n        onChange={handleChange}\n        customInput={TextField}\n        thousandSeparator\n        valueIsNumericString\n        prefix=\"$\"\n        variant=\"standard\"\n        label=\"react-number-format\"\n      />\n    </Stack>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 71,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "react-imask",
      "react-number-format",
      "@mui/material/Stack",
      "@mui/material/Input",
      "@mui/material/InputLabel",
      "@mui/material/TextField",
      "@mui/material/FormControl"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
